import detailApiCall from './detail'

const ApiCall = {
  detail: detailApiCall
}

export default ApiCall
